const DUPLICATE = 'duplicate';
const UNIQUE = 'unique';

export function indexPreviewItems(preview) {
	const index = new Map();
	const payments = preview && Array.isArray(preview.payments) ? preview.payments : [];

	payments.forEach(payment => {
		if (!payment || payment.category === 'SMA') {
			return;
		}

		const items = Array.isArray(payment.items) ? payment.items : [];
		items.forEach(item => {
			if (!item) {
				return;
			}

			const key = item.establishment;
			if (index.has(key)) {
				index.set(key, { status: DUPLICATE });
				return;
			}

			index.set(key, { status: UNIQUE, item });
		});
	});

	return index;
}

function uniqueItem(index, rowName) {
	const entry = index && index.get(rowName);
	if (!entry || entry.status !== UNIQUE) {
		return undefined;
	}

	return entry.item;
}

export function descriptionForRow(index, rowName) {
	const item = uniqueItem(index, rowName);
	if (!item || item.description == null) {
		return '';
	}

	return item.description;
}

export function itemForRow(index, rowName) {
	return uniqueItem(index, rowName);
}
